import React from 'react';
import styled from '@benzinga/themetron';
import { sanitizeHTML } from '@benzinga/frontend-utils';
import { extractImageSize, BzImage } from '@benzinga/image';
import { CoreElementWrapper, CoreImageWrapper } from '../CoreElement';
import classNames from 'classnames';

export interface CoreImageProps {
  block: any;
}

export const CoreImage: React.FC<CoreImageProps> = ({ block }) => {
  if (block.image) {
    const image = extractImageSize(block.image, block.attrs?.sizeSlug);
    if (!image && block.innerHTML) {
      return <CoreElementWrapper dangerouslySetInnerHTML={{ __html: block.innerHTML }} />;
    } else if (!image) {
      return <div />;
    }
    const imageUrl = image?.url;

    const width = block.attrs.width ?? image.width ?? 200;
    const height = block.attrs.height ?? (image.height && image.width ? (image.height * width) / image.width : 200);
    const layout = block.attrs?.layout || 'intrinsic';

    const Image = (
      <BzImage
        alt={block.image?.alt || block.image?.title}
        height={height}
        layout={layout}
        sizes={`(max-width: 800px) ${width}px, (min-width: 800px) ${width}px`}
        src={imageUrl}
        width={width}
      />
    );

    const ImageComponent = (
      <CoreImageWrapper className="core-image">
        {block.href ? (
          <a href={block.href} rel="noreferrer" target="_blank">
            {Image}
          </a>
        ) : (
          Image
        )}
        {block.image?.caption && block.image.caption.trim() && (
          <div className="image-caption" dangerouslySetInnerHTML={{ __html: sanitizeHTML(block.image.caption) }} />
        )}
      </CoreImageWrapper>
    );
    return (
      <CoreElementWrapper
        className={classNames('image-wrapper', {
          [`${block.attrs.align}`]: !!block.attrs.align,
          [`${block.attrs.className}`]: !!block.attrs.className,
        })}
      >
        {ImageComponent}
      </CoreElementWrapper>
    );
  } else if (block?.tagAttributes) {
    const imageUrl = block?.tagAttributes?.src;
    const width = block?.tagAttributes?.width ?? 800;
    const height = block?.tagAttributes?.height ?? 450;

    const ImageComponent = (
      <BzImage
        alt={block.image?.alt || block.image?.title || ''}
        height={height}
        layout="intrinsic"
        sizes={`(max-width: 800px) ${width}px, (min-width: 800px) ${width}px`}
        src={imageUrl}
        width={width}
      />
    );

    return (
      <CoreElementWrapper className="core-image flex items-center justify-center">
        {block.href ? (
          <a href={block.href} rel="noreferrer" target="_blank">
            {ImageComponent}
          </a>
        ) : (
          ImageComponent
        )}
      </CoreElementWrapper>
    );
  } else {
    return <div dangerouslySetInnerHTML={{ __html: sanitizeHTML(block.innerHTML) }} style={{ display: 'contents' }} />;
  }
};

export const Container = styled.div`
  &.wp-block-image {
    padding: 0.5rem;
    flex-grow: 1;
    min-width: 0;
    word-break: break-word;
    overflow-wrap: break-word;
    h2 {
      margin-top: 0;
    }
    @media (min-width: 782px) {
      flex-basis: 0;
      flex-grow: 1;
    }
    @media (max-width: 600px) {
      flex-basis: 100% !important;
    }
  }
`;
